module.exports = __webpack_public_path__ + "static/media/bg_1.bd212343.jpg";